
export default {
  getHistorySid(state) {
    return state.historySid
  },
  getHistoryKey(state) {
    return state.historyKey
  },
  getHistorySubKey(state) {
    return state.historySubKey
  },
  getPageCount(state) {
    const items = state.history && state.history.pages ? state.history.pages : {}
    return Object.keys(items).map((key)=>{ if (key != '.key') return items[key] }).length
  },
  getLastPage(state) {

    const items = state.history && state.history.pages ? state.history.pages : {}

    let page = null
    let lastLeftAt = 0
    for (let i in items)
      if (items[i] &&
        items[i].left_at &&
        items[i].left_at > lastLeftAt
      ) {

        lastLeftAt = items[i].left_at
        page = {
          pageKey: i,
          ...items[i]
        }

      }

    return page

  }
}
